module.exports = __webpack_public_path__ + "img/stroke-edit.65fa43.svg";